module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-9-128.67bf1b622061af69.png"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-9-128.67bf1b622061af69.png",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-9-128.67bf1b622061af69.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-9-128.67bf1b622061af69.png"},
        
        width: 128,
        height: 85
      }